/**
 * This is a config file for all listing types. There are multiple listing type,
 * such as search, brand, private sale and category. There are excluded filters
 * for theses listing. For example, in brand listing, we don't want brand filters
 */
import useUser from './externalData/useUser';

export default () => {
    const { isB2B } = useUser();

    const listingTypeConfig = {
        category: {
            excludedFilters: [
                'categories.last',
                'categories.l3.id',
                'categories.l2.id',
                'categories.last_id',
            ],
        },

        brand: {
            excludedFilters: ['brand_name', 'categories.last_id'],
        },

        vp: {
            excludedFilters: ['private_sale_ids'],
        },

        search: {
            excludedFilters: [
                'categories.last',
                'categories.l3.id',
                'categories.l2.id',
                'categories.last_id',
            ],
        },

        mandatoryFilters: [
            'brand_name',
            'seller_name',
            'is_mmf',
            'price',
            'has_3x_payment',
            'has_free_delivery',
            'has_1day_delivery',
            'has_relay_delivery',
            'categories.last',
        ],
    };
    if (isB2B) listingTypeConfig.mandatoryFilters.push('has_pro_conditions');

    return listingTypeConfig;
};
